<template>
    <div id="menuPage">
        <screen ref='screen'></screen>
    </div>
</template>

<script>

import Screen from 'views/cdu/cduHeader/Screen'

import {initMenu} from 'utils/initPageData'


export default {
    name: 'MenuPage',
    components: {
        Screen
    },
    data() {
        return {
            page1: [
            [
                ['MENU',['','','']],
                [1,1]
            ],
            [
                [ '', '' ], 
                [ '<FMC', '' ] 
            ], 
            [ 
                [ '', '' ], 
                [ '<ACARS', '' ] 
            ],
            [ 
                [ '', '' ], 
                [ '<DFDAU', '' ] 
            ],
            [ 
                [ '', '' ], 
                [ '', '' ] 
            ],
            [ 
                [ '', '' ], 
                [ '', '' ] 
            ],
            [ 
                [ '', '' ], 
                [ '', 'SETUP>' ] 
            ]
        ]
        }
    },
    methods: {
        initPage(){
            this.index = this.page1[0][1]
            this.showData = this['page'+ this.index[0]]
        }
    },
    created() {
        this.initPage()
        initMenu(this)
    }

}
</script>

<style scoped>

</style>